<template>
    <Layout>
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between">
                    <h4 class="card-title">{{ $t('sms.send_sms') }}</h4>
                    <a href="#list" class="badge bg-pink"><i class="fas fa-table me-1"></i> {{ $t('sms.show_sent') }}</a>
                </div>
            </div>
            <div class="card-body">
                <component :is="toList ? 'list' : 'single'" :deflink="link" :isUtf8="isUtf8" :message="message" @update:IsUtf8="updateIsUtf8" @updateToList="updateToList" @update:link="updateLink" @update:message="updateMessage"></component>
            </div>
        </div>
        <div class="card" id="list" name="list">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h4 class="card-title">
                        {{ $t(toList ? 'sms.messages_sent_to_list' : 'sms.messages_sent_to_single') }}
                    </h4>
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <span class="cursor-pointer d-inline-block px-2"><i class="fas fa-ellipsis-v"></i></span>
                        </template>
                        <b-dropdown-item href="#" @click="reloadTable"><i class="fas fa-spinner me-2"></i>{{ $t('table.reload') }}</b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
            <div class="card-body p-0">
                <component :is="toList ? 'list-table' : 'single-table'" :updateKey="tableUpdate"></component>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "@/views/layouts/table";
import Single from "./single";
import List from "./list";
import ListTable from "./list-table.vue";
import SingleTable from "./single-table.vue";

export default {
    name: "send",

    components: {
        ListTable,
        SingleTable,
        Layout,
        Single,
        List
    },

    computed: {
        userUtf8: function () {
            return this.$store.getters['auth/currentUser'].is_sms_utf8;
        }
    },

    data: function () {
        return {
            toList: false,
            message: null,
            link: {},
            isUtf8: false,
            tableUpdate: 1
        }
    },

    methods: {
        updateToList: function (boolean) {
            this.toList = boolean;
        },

        updateMessage: function (message) {
            this.message = message;
        },

        updateLink: function (link) {
            this.link = link;
        },

        updateIsUtf8: function (boolean) {
            this.isUtf8 = boolean;
        },

        reloadTable: function () {
            this.tableUpdate++;
        },
    },

    watch: {
        userUtf8: {
            immediate: true,
            handler: function (value) {
                if (value === 0 || value === '0' || value === '' || value === null) {
                    this.isUtf8 = false;
                } else {
                    this.isUtf8 = true;
                }
            }
        },
    },

    created() {
        document.title = this.setTitle(this.$t('sms.send_sms'));
    }
}
</script>

<style scoped>

</style>
